export default "__VITE_ASSET__db81e754__"